
const INITIAL_STATE = { status: false }

const ControlCloseModal = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_CONTROL_CLOSE_MODAL_CHANGE':
            return { status: action.payload }
        default:
            return state;
    }
}

export default ControlCloseModal